import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { COMPANY, NAV_LINKS, waLink } from '../data/company';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <motion.header initial={{
    y: -80,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${scrolled ? 'bg-ink/90 backdrop-blur-md border-b border-gold/15 py-3' : 'bg-transparent py-5'}`} data-id="element-134" data-mp="lpolyjjm4jf">
      <nav className="mx-auto max-w-7xl px-5 flex items-center justify-between" data-id="element-135" data-mp="1kzzs6fipk8id">
        <a href="#beranda" className="flex items-center gap-2 group" data-id="element-136" data-mp="9ohhxf8t37oc">
          <span className="grid h-10 w-10 place-items-center rounded-lg gold-border bg-ink-card" data-id="element-137" data-mp="9qk8q1hs94u4">
            <span className="font-display text-lg font-bold text-gold-gradient shimmer" data-id="element-138" data-mp="epnfbqdevj47">WP</span>
          </span>
          <span className="leading-tight" data-id="element-139" data-mp="jkt0uo2wivrr">
            <span className="block font-display text-base font-semibold text-white" data-id="element-140" data-mp="om04qc1xbat5">WP Transport</span>
            <span className="block text-[10px] tracking-[0.25em] text-gold/80 uppercase" data-id="element-141" data-mp="3n4f933hd6jnp">Luxury Rental</span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-8" data-id="element-142" data-mp="3s0co96gw5jyw">
          {NAV_LINKS.map(l => <li key={l.href} data-id="element-143" data-mp="uup9xzwakjd">
              <a href={l.href} className="relative text-sm text-white/75 hover:text-gold transition-colors after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-gold after:transition-all hover:after:w-full" data-id="element-144" data-mp="5mm8tokmvq00">
                {l.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden lg:block" data-id="element-145" data-mp="319gmmyvv2bsx">
          <a href={waLink(`Halo ${COMPANY.name}, saya ingin sewa mobil.`)} target="_blank" rel="noopener noreferrer" className="btn-glow-gold inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold" data-id="element-146" data-mp="2wcgcabrzamw0">
            <PhoneIcon className="h-4 w-4" data-id="element-147" data-mp="2icfej570fvkr" /> Sewa Sekarang
          </a>
        </div>

        <button onClick={() => setOpen(o => !o)} className="lg:hidden grid h-10 w-10 place-items-center rounded-lg gold-border text-gold" aria-label="Buka menu" data-id="element-148" data-mp="2iei45o493moy">
          {open ? <XIcon className="h-5 w-5" data-id="element-149" data-mp="2nbi8nulgchdy" /> : <MenuIcon className="h-5 w-5" data-id="element-150" data-mp="2nb8sszu4fqlz" />}
        </button>
      </nav>

      <AnimatePresence data-id="element-151" data-mp="7kcgxlb2wdf7">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden overflow-hidden border-t border-gold/15 bg-ink/95 backdrop-blur-md" data-id="element-152" data-mp="7j1fhs53vhr9">
            <ul className="px-5 py-4 space-y-1" data-id="element-153" data-mp="f459szovv8ke">
              {NAV_LINKS.map(l => <li key={l.href} data-id="element-154" data-mp="14m2g93wc195">
                  <a href={l.href} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-3 text-sm text-white/80 hover:bg-gold/10 hover:text-gold" data-id="element-155" data-mp="15otqi54s5pl">
                    {l.label}
                  </a>
                </li>)}
              <li className="pt-2" data-id="element-156" data-mp="xw7jts70rqlo">
                <a href={waLink(`Halo ${COMPANY.name}, saya ingin sewa mobil.`)} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="btn-glow-gold flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold" data-id="element-157" data-mp="k3htxcode1ja">
                  <PhoneIcon className="h-4 w-4" data-id="element-158" data-mp="3p1xct4mguq9n" /> Sewa Sekarang
                </a>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
}